import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
    selector: 'account-setup-nav',
    templateUrl: './account-setup-nav.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule
    ]
})
export class AccountSetupNavComponent implements OnInit, AfterViewInit {
  @Input() tabs;
  @Input() selectedIndex;
  @Input() isDiscovery = false;
  @Output() menuSelectionEventEmitter = new EventEmitter();
  @ViewChild('menuContainer', { static: false }) menuContainer: ElementRef;

  selected: FormControl;
  leftDisabled = true;
  rightDisabled = false;
  constructor() {}

  ngOnInit(): void {
    this.selected = new FormControl(this.selectedIndex);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.scrollRight(this.selectedIndex);
    }, 100);
  }
  menuSelectEvent(event) {
    this.selected.setValue(event);
    this.menuSelectionEventEmitter.emit(event);
    this.scrollRight(event);
  }

  scrollRight(index?: any) {
    const myDiv = document.getElementById(`${(index + 1) || index}`);
    myDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
